import { Color } from 'three';

const _colorsCache: { [hex: string]: Color } = {};

export function hex(color: Color): string {
  return `#${color.getHexString()}`;
}

export function color(hexString: string): Color {
  if (!_colorsCache[hexString]) {
    _storeColor(new Color(hexString));
  }

  return _colorsCache[hexString];
}

export function offsetHSL(
  hexString: string,
  l: number = 0,
  s: number = 0,
  h: number = 0,
): Color {
  const key = `${hexString}/o${l}${s}${h}`;

  if (!_colorsCache[key]) {
    const color = new Color(hexString);
    color.offsetHSL(h, s, l);
    _storeColor(color, key);
  }

  return _colorsCache[key];
}

function _storeColor(color: Color, key = `#${color.getHexString()}`) {
  _colorsCache[key] = color;
}
